module.exports = __webpack_public_path__ + "static/government-7b96edd418cd964ae1e6447a49b0bebf.png";